export default __webpack_public_path__ + "static/media/qr-code-placeholder-square.8a91725e.png";